import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Spinner from '../../components/Layout/Spinner';
import PaymentForm from './PaymentForm';

const SubscriptionCheckout = () => {
  const { planId } = useParams();
  const navigate = useNavigate();
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [processingPayment, setProcessingPayment] = useState(false);

  useEffect(() => {
    const fetchPlanDetails = async () => {
      try {
        const res = await axios.get(`/api/v1/member-subscription-plans/${planId}`);
        setPlan(res.data.data);
        setLoading(false);
      } catch (err) {
        toast.error(err.response?.data?.error || 'Error fetching plan details');
        navigate('/member/subscription-plans');
      }
    };

    fetchPlanDetails();
  }, [planId, navigate]);

  const handlePaymentSubmit = async (paymentDetails) => {
    setProcessingPayment(true);
    
    try {
      // Process payment and create subscription
      const res = await axios.post('/api/v1/member-subscriptions', {
        plan: planId,
        paymentDetails
      });
      
      toast.success('Subscription activated successfully!');
      navigate('/member/my-subscription');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Payment processing failed');
      setProcessingPayment(false);
    }
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Subscribe to Plan</h2>
      
      <div className="row">
        <div className="col-md-6">
          <div className="card mb-4">
            <div className="card-header bg-primary text-white">
              <h4>{plan.name}</h4>
            </div>
            <div className="card-body">
              <h5 className="card-title text-center mb-3">${plan.price}</h5>
              <h6 className="text-muted text-center mb-4">{plan.duration} days</h6>
              <p className="card-text">{plan.description}</p>
              
              <h5>Features:</h5>
              <ul className="list-group list-group-flush mb-4">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="list-group-item">
                    <i className="fas fa-check text-success me-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        
        <div className="col-md-6">
          <div className="card">
            <div className="card-header bg-secondary text-white">
              <h4>Payment Details</h4>
            </div>
            <div className="card-body">
              <PaymentForm 
                amount={plan.price} 
                onPaymentSubmit={handlePaymentSubmit}
                isProcessing={processingPayment}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCheckout;
